module.exports = __webpack_public_path__ + "static/media/sprite.e3ce035f.png";